import {MdEmail} from 'react-icons/md'
import {BsMessenger} from 'react-icons/bs'
import {RiWhatsappFill} from 'react-icons/ri'

export const data = [ 
    {id:1, name:"Email", mail:"aswin@gmail.com", icon:<MdEmail className='contact-option-icon'/>,href:"mailto:aswindevsr@gmail.com"},
    {id:1, name:"Messenger", mail:"aswin@gmail.com", icon:<BsMessenger className='contact-option-icon'/>,href:"https://m.me/aswin.devsr"},
    {id:1, name:"WhatsApp", mail:"+919895547713", icon:<RiWhatsappFill className='contact-option-icon'/>,href:"https://api.whatsapp.com/send?phone=919895547713"},

]